import React  from 'react';
//import { Error500 } from '../HomePage/Error500';


class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false, 
            error: { message: '', stack: '' },
            info: { componentStack: '' }    
        };
    }

    componentDidCatch = (error, info) => {
        this.setState({ error, info });
    };

    static getDerivedStateFromError = error => {
        return { hasError: true };
    };

    render() {
        const { hasError} = this.state;
        const { children } = this.props;

        if (hasError) {
            return (<div>THIS IS ERROR 500</div>)
        }
        else {
            return (children);
        }
    } 
}

export { ErrorBoundary }; 